import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { Redirect } from "react-router";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import FontAwesome from "react-fontawesome";
import SensorTypeDropdown from "../SensorTypeDropdown";
import ObservationSelectorMap from "../ObservationSelectorMap";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import _ from "lodash";
import { pageNotes } from "../../_actions";
import { Row, Col, form, FormGroup, FormControl, ControlLabel, Button, HelpBlock, Modal, Media } from "react-bootstrap";
import "./index.css";

class ObservationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetFilter: false,
      isImageUploading: false,
      showObservationMapModal: false,
      files: [],
      params: {
        title: "",
        description: "",
        discipline: null,
        investigation_required: false
      }
    };
  }

  componentDidMount() {
    this.props.pageNotes();
  }

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {}
      };
    });
  };

  handleClose = () => {
    this.setState({ showObservationMapModal: false });
  };

  setObservationDescription = e => {
    const params = this.state.params;
    params.description = e.target.value;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  removeSpaces = tmpValue => {
    return tmpValue.trim();
  };

  setObservationTitle = e => {
    const params = this.state.params;
    params.title = e.target.value;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setDiscipline = val => {
    const params = this.state.params;
    params.discipline = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setLocation = () => {
    const params = this.state.params;
    params.location = this.state.selectedPointOnMap;
    this.setState(() => {
      return {
        params: params,
        showObservationMapModal: false,
        resetFilter: false
      };
    });
  };

  selectedLocationPoint = val => {
    this.setState({ selectedPointOnMap: val });
  };

  setLocationPickerState = () => {
    this.setState({ showObservationMapModal: true });
  };

  handleInvestigationToggleChange = val => {
    const params = this.state.params;
    params.investigation_required = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setLoadingState = val => {
    this.setState({ loading: val });
  };

  createObservation = () => {
    const params = this.state.params;
    const { files } = this.state;
    this.setState(() => {
      return {
        validated: true,
        isImageUploading: true,
        displayWaitText: "Please wait while the Observation is being created"
      };
    });

    const trimmedDescription = this.removeSpaces(params.description);
    const trimmedTitle = this.removeSpaces(params.title);
    params.title = trimmedTitle;
    params.description = trimmedDescription;

    this.setState(
      () => {
        return { params: params };
      },
      () => {
        if (
          params.title &&
          params.title.length > 0 &&
          params.description.length > 0 &&
          params.description &&
          params.discipline &&
          params.location
        ) {
          const url = "/api/v1/observations/";
          const errorMsg = "Unable to create an observation.";

          api.postFetch(url, params, this.props.user.token, errorMsg, true).then(json => {
            if (json) {
              if (json.id && files) {
                const url = "/api/v1/observation_photos/";
                const errorMsg = "Unable to upload a photo.";

                _.each(files, (file, index) => {
                  const data = new FormData();
                  data.append("image_file", file);
                  data.append("observation", json.id);

                  api.postFormData(url, data, this.props.user.token, errorMsg).then(json => {
                    if (json && index === files.length - 1) {
                      this.setState(
                        () => {
                          return { displayWaitText: "Observation is created successfully." };
                        },
                        () => {
                          this.setState({ redirect: "/notes/" });
                        }
                      );
                    }
                  });
                });
              }
            }
          });
        }
      }
    );
  };

  cancelObservationGeneration = () => {
    this.props.history.goBack();
  };

  renderMainTitle = () => {
    return (
      <div className="mainTitle">
        <h1>Create New Observation</h1>
      </div>
    );
  };

  renderDisciplinePickerRow = () => {
    const { validated } = this.state;
    return (
      <SensorTypeDropdown
        loading={this.setLoadingState}
        change={this.setDiscipline}
        reset={this.state.resetFilter}
        observationPage={true}
        observationValidated={validated}
        defaultValue={this.state.params.discipline}
      />
    );
  };

  renderInvestigationToggleRow = () => {
    const { investigation_required } = this.state.params;
    return (
      <div className="toggleRow">
        <label htmlFor="investigation-switch">
          <span>Does this observation need further investigation?</span>
          <Switch
            onChange={this.handleInvestigationToggleChange}
            checked={investigation_required}
            onColor="#00bad4"
            height={31}
            className="react-switch"
            id="investigation-switch"
          />
        </label>
      </div>
    );
  };

  renderLocationPickerRow = () => {
    const { params, validated } = this.state;
    let locationDetails;

    if (!params.location) {
      locationDetails = (
        <Button bsStyle="primary" onClick={() => this.setLocationPickerState()}>
          <FontAwesome name="map-marker-alt" />
          Drop location pin
        </Button>
      );
    } else {
      const trimmedLatitude = params.location.latitude.toFixed(5);
      const trimmedLongitude = params.location.longitude.toFixed(5);
      locationDetails = (
        <div className="selectedObervation">
          <FontAwesome name="map-marker-alt" />
          {trimmedLatitude + "," + trimmedLongitude}
          <a className="link changeLocation" onClick={() => this.setLocationPickerState()}>
            Change location
          </a>
        </div>
      );
    }

    return (
      <div className="ObservationLocation">
        <FormGroup controlId="locationInputarea" validationState={validated && !params.location ? "error" : null}>
          <ControlLabel>Location</ControlLabel>
          <br />
          {locationDetails}
          {validated && !params.location ? (
            <HelpBlock>
              <FontAwesome name="exclamation-circle" />Please select a location.
            </HelpBlock>
          ) : null}
        </FormGroup>
      </div>
    );
  };

  renderTitleRow = () => {
    const { params, validated } = this.state;

    return (
      <FormGroup
        controlId="observationTextarea"
        validationState={validated && !this.removeSpaces(params.title) ? "error" : null}
      >
        <ControlLabel>Observation summary</ControlLabel>
        <FormControl
          name="observationSumary"
          type="text"
          placeholder="Enter an observation summary"
          value={params.title}
          onChange={this.setObservationTitle}
        />
        {validated && !this.removeSpaces(params.title) ? (
          <HelpBlock>
            <FontAwesome name="exclamation-circle" /> Please enter an observation summary.
          </HelpBlock>
        ) : null}
      </FormGroup>
    );
  };

  renderDescriptionInputRow = () => {
    const { params, validated } = this.state;

    return (
      <FormGroup
        controlId="observationTextarea"
        validationState={validated && !this.removeSpaces(params.description) ? "error" : null}
      >
        <ControlLabel>Observation details</ControlLabel>
        <FormControl
          name="observationDetails"
          componentClass="textarea"
          placeholder="Enter observation details"
          value={params.description}
          onChange={this.setObservationDescription}
        />
        {validated && !this.removeSpaces(params.description) ? (
          <HelpBlock>
            <FontAwesome name="exclamation-circle" /> Please enter the observation details.
          </HelpBlock>
        ) : null}
      </FormGroup>
    );
  };

  onDrop = file => {
    this.setState({
      files: this.state.files.concat(file.map(file => Object.assign(file, { preview: URL.createObjectURL(file) })))
    });
  };

  onRemove = index => {
    const stateFiles = this.state.files;
    stateFiles.splice(index, 1);
    this.setState({
      files: stateFiles
    });
  };

  renderImageUploadRow = () => {
    const { files } = this.state;

    const uploadIcon = (
      <span>
        <b>Choose image</b> or drag and drop images here
      </span>
    );
    return (
      <FormGroup controlId="imageUploadArea">
        <ControlLabel>Image Upload</ControlLabel>
        <Dropzone
          multiple={true}
          onDrop={e => this.onDrop(e)}
          accept="image/jpeg, image/png"
          className="uploadDivContainer"
          inputProps={{ capture: "camera" }}
        >
          {uploadIcon}
        </Dropzone>
        {files &&
          files.length > 0 && (
            <div className="upload-file-list">
              <ul>
                {files.map((file, index) => (
                  <li key={index}>
                    <Media>
                      <Media.Left>
                        <FontAwesome name="fas fa-upload" className="uploadIcon" />
                      </Media.Left>
                      <Media.Body>
                        {file.name} - {file.size} bytes
                        <a className="btn-close" onClick={() => this.onRemove(index)}>
                          <FontAwesome name="times" />
                        </a>
                      </Media.Body>
                    </Media>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </FormGroup>
    );
  };

  renderButtonRow = () => {
    return (
      <div className="buttonContainer buttonRow">
        <Button className="btn-cancel" bsStyle="default" onClick={this.cancelObservationGeneration}>
          Cancel
        </Button>
        <Button className="btn-filter" bsStyle="primary" onClick={this.createObservation}>
          Create Observation
        </Button>
      </div>
    );
  };

  renderLocationSelectionModal = (showObservationMapModal, handleClose) => {
    return (
      <div className="modal-container">
        <Modal className="modal-alert" show={showObservationMapModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Move location pin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ObservationSelectorMap selectedLocationPoint={this.selectedLocationPoint} />
          </Modal.Body>
          <Modal.Footer>
            <div className="buttonContainer">
              <Button className="btn-cancel" bsStyle="default" onClick={() => this.handleClose()}>
                Cancel
              </Button>
              <Button className="btn-filter" bsStyle="primary" onClick={() => this.setLocation()}>
                Set Location
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderMainContent = () => {
    return (
      <div className="mainContent">
        <Row>
          <Col md={6}>
            <div className="panel-div createObservationPanel">
              <form>
                {this.renderTitleRow()}
                {this.renderDescriptionInputRow()}
                {this.renderLocationPickerRow()}
                {this.renderDisciplinePickerRow()}
                {this.renderImageUploadRow()}
                {this.renderInvestigationToggleRow()}
                {this.renderButtonRow()}
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderImageLoadingPage = () => {
    const { displayWaitText } = this.state;

    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="mainPanelCon">
          <div className="container">
            {this.renderMainTitle()}
            <div className="mainContent">
              <Row>
                <Col md={6}>
                  <div className="panel-div createObservationPanel">
                    <div className="loading-con">{displayWaitText}</div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isImageUploading } = this.state;

    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }

    if (!isImageUploading) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle()}
              {this.renderMainContent()}
            </div>
          </div>
          {this.renderLocationSelectionModal(this.state.showObservationMapModal, this.handleClose)}
        </div>
      );
    } else {
      return <div>{this.renderImageLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(
  mapStateToProps,
  { pageNotes }
)(ObservationPage);



// WEBPACK FOOTER //
// ./src/_components/ObservationPage/index.js